import React from "react";
import { Dialog } from "@mui/material";

export function DialogContainer({ children, open, onClose, onKill, disableBackdropClick, fullWidth, maxWidth }: any) {
  return (
    <Dialog
      disableBackdropClick={disableBackdropClick == null ? false : disableBackdropClick}
      fullWidth={fullWidth}
      maxWidth={maxWidth ?? "lg"}
      onClose={onClose}
      onExited={onKill}
      open={open}
    >
      {children}
    </Dialog>
  );
}
